import SalonBusinessCpaTopicPage from "./SalonBusinessCpaTopicPage";

export default function SalonBusinessCpaCorporateTax() {
  return (
    <SalonBusinessCpaTopicPage
      title="Corporate tax"
      description="Prepare year-end corporate records for Canadian salon corporations."
      sections={[
        {
          title: "Company records",
          body: "Confirm the basic information needed for filing.",
          items: ["Legal company name", "Business number", "Year-end date"],
        },
        {
          title: "Year-end package",
          body: "Collect the records your accountant will use for the return.",
          items: ["Financial statements", "Asset purchases", "Loan and lease details"],
        },
        {
          title: "Owner items",
          body: "Keep owner-related transactions easy to review.",
          items: ["Salary and dividends", "Shareholder loan activity", "Home office notes"],
        },
      ]}
    />
  );
}
